<template>
    <div class="BarChartVertical">
        <p v-if="hasTitle" class="homeComTitle hasLine">
            <span class="titleLine"></span>
            <span class="flex_1">{{ title }}</span>
        </p>
        <section v-if="!noData">
            <div class="fs14 mt12" v-if="hasContent" v-html="content"></div>
            <div :class="{ isChannel: isChannel }" class="chartBox mt28" :id='chartId'></div>
        </section>
        <img v-else class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
    </div>
</template>

<script>
import utils from '../../util/common.js'
import _ from 'lodash'

const echarts = require('echarts');

export default {
    name: "BarChartVertical",
    props: {
        isChannel: Boolean, // 是否为渠道报道倾向
        hasTitle: Boolean, // 是否有标题
        hasContent: Boolean, // 是否有文案
        title: {
            type: String,
            default: '事件影响力分布'
        },
        renderData: Object,
        chartId: {
            type: String,
            default: "doubleBar"
        },
        chartTitle: {
            type: String,
            default: "事件数(件)"
        },
        keyData: {
            type: Array,
            default: () => {
                return ['label', 'count']
            }
        },
        labelData: Array,
        timeData: String,
        entityType: {
            type: String,
            default: "company"
        }
    },
    data() {
        return {
            chart: null,
            content: null,
            maxTotal: 0,
            noData: false,
        }
    },
    mounted() {
        if (this.hasContent)
            this.setContent()
        else {
            this.renderFunc()
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        setContent() {
            let {target1, target2} = this.renderData;
            let total1 = _.sumBy(target1, 'total'),
                negative1 = _.sumBy(target1, 'negative'),
                positive1 = _.sumBy(target1, 'positive'),
                total2 = _.sumBy(target2, 'total'),
                negative2 = _.sumBy(target2, 'negative'),
                positive2 = _.sumBy(target2, 'positive');

            let useWord = this.isChannel ? '报道' : '事件';
            let unit = this.isChannel ? '篇' : '件';
            let entityLabel = this.entityType == "industry" ? "行业" : "企业";
            let useText = this.isChannel ? `本${entityLabel}${ this.entityType == "company" ? "主体性报道" : "舆情报道"}` : `本${entityLabel}正面、中性及敏感事件共`;

            this.maxTotal = Math.max(...target1.map(item => item.total), ...target2.map(item => item.total))
            this.renderFunc()

            this.content = `<p>${this.labelData[0]}：${this.timeData}，${useText + total1 + unit}，其中敏感${useWord + negative1 + unit}，占比${
                utils.formatPercentAndCeil(negative1, total1)}%；正面${useWord + positive1 + unit}，占比${utils.formatPercentAndCeil(positive1, total1)}%。</p>`

            this.content += `<p>${this.labelData[1]}：${this.timeData}，${useText + total2 + unit}，其中敏感${useWord + negative2 + unit}，占比${
                utils.formatPercentAndCeil(negative2, total2)}%；正面${useWord + positive2 + unit}，占比${utils.formatPercentAndCeil(positive2, total2)}%。</p>`
        },
        renderFunc() {
            let colorData = ['#376CCF', '#F29E01'],
                fontObject = {
                    color: "#666666",
                    fontSize: 11
                }
            let {target1, target2} = this.renderData;
            let key = this.keyData[1] || "total";
            let total1 = _.sumBy(target1, key),
                total2 = _.sumBy(target2, key);

            if (!total1 && !total2) {
                this.noData = true
                return
            }
            this.noData = false

            this.chart = echarts.init(document.getElementById(this.chartId));

            let option = {
                grid: {
                    top: '20%',
                    left: '10%',
                    right: '10%',
                    bottom: '2%',
                    containLabel: true,
                },

                xAxis: {
                    type: this.isChannel ? 'value' : 'category',
                    axisTick: {show: false},
                    axisLine: {
                        lineStyle: {
                            type: [5, 10],
                            dashOffset: 5,
                            color: '#DEDEDE',
                        }
                    },
                    axisLabel: {
                        rotate: 45,
                        textStyle: fontObject
                    },
                },
                yAxis: {
                    type: this.isChannel ? 'category' : 'value',
                    name: this.chartTitle,
                    nameTextStyle: {
                        ...fontObject,
                        lineHeight: 30,
                    },
                    label: {
                        show: true
                    },
                    axisLine: { //  改变y轴颜色
                        show: false,
                    },
                    axisLabel: {
                        textStyle: fontObject,
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['#DEDEDE'],
                            fontSize: 10,
                            width: 1,
                            type: 'dotted'
                        }
                    }
                },
                series: [{
                    type: 'bar',
                    smooth: true,
                    symbol: 'none',
                    barGap: 1,
                    barWidth: 8,
                    data: target1.map(item => item[this.keyData[1]]),
                    itemStyle: {
                        normal: {
                            color: colorData[0],
                            barBorderRadius: 4,
                            label: {
                                show: true,
                                position: this.isChannel ? 'right' : 'top', // label 显示位置
                                color: '#666666',
                            },
                        }
                    },
                }, {
                    type: 'bar',
                    smooth: true,
                    symbol: 'none',
                    barWidth: 8,
                    data: target2.map(item => item[this.keyData[1]]),
                    itemStyle: {
                        normal: {
                            color: colorData[1],
                            barBorderRadius: 4,
                            label: {
                                show: true,
                                position: this.isChannel ? 'right' : 'top', // label 显示位置
                                color: '#666666',
                            },
                        }
                    },
                }],
            };
            // if(this.hasTitle) {
            option.series.forEach((item, index) => {
                item.name = this.labelData[index]
            })
            option.legend = {
                data: this.labelData,
                right: 26,
                top: 4,
                itemWidth: 4,
                icon: 'circle',
                textStyle: {
                    color: colorData,
                    fontSize: 11,
                }
            }
            // }
            if (this.isChannel) {
                option.yAxis.nameLocation = 'end';
                option.grid.top = '12%';
                option.grid.left = '5%';
                delete option.legend.top
                delete option.legend.right
                // option.legend.x = "200px"
                option.yAxis.splitLine.show = false;
                let yAxis_v2 = option.yAxis;
                option.yAxis = [{
                    type: this.isChannel ? 'category' : 'value',
                    nameTextStyle: {
                        ...fontObject,
                        lineHeight: 30,
                    },
                    label: {
                        show: true
                    },
                    axisLine: { //  改变y轴颜色
                        show: false,
                    },
                    axisLabel: {
                        textStyle: fontObject,
                    },
                    axisTick: {
                        show: false
                    },
                    data: target1.map(item => item[this.keyData[0]])
                }, yAxis_v2]
                option.xAxis.axisLine.show = false;
                option.xAxis.axisLabel.rotate = 0;
                option.xAxis.axisLabel.hideOverlap = false;
                option.xAxis.splitLine = {
                    show: true,
                    lineStyle: {
                        color: ['#DEDEDE'],
                        fontSize: 10,
                        width: 1,
                        type: 'dotted'
                    }
                }
                option.xAxis.axisLabel.formatter = function (count) {
                    if(count % 10000 == 0  && Math.log10(count) >=4 && count){
                        return  `${count / 10000}万`
                    }
                    return  `${count}`
                };
                // if (this.maxTotal > 0) {
                    // option.xAxis.interval = this.maxTotal / 2;
                    // option.xAxis.max = this.maxTotal + option.xAxis.interval;
                // }
            } else {
                option.xAxis.data = target1.map(item => item[this.keyData[0]]);
            }
            this.chart.setOption(option);
        }
    }
}
</script>

<style lang="scss" scoped>
.BarChartVertical {
    padding: 16px;

    .isChannel {
        height: 350px;
    }
}
</style>